export default __webpack_public_path__ + "static/media/logo.350e0339.png";